import { render, staticRenderFns } from "./StockIn.vue?vue&type=template&id=0d1219a8&scoped=true"
import script from "./StockIn.vue?vue&type=script&lang=js"
export * from "./StockIn.vue?vue&type=script&lang=js"
import style0 from "../../../assets/styles/inventory.css?vue&type=style&index=0&id=0d1219a8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1219a8",
  null
  
)

export default component.exports